import React from 'react';
import { GenericCollection, JSONLD } from 'react-structured-data';
import { SearchAction, WebSite } from './MicrodataComponents';
import { canonicalBaseUrl, womenSearchUrl } from '../../helpers/routes';
import withCountryCode from '../../components/RoutesHoc/RoutesHoc';

const searchParamPlaceholder = 'search_term_string';

const HomeMicrodata = ({ buildUrlWithCountry }) => {
  return (
    <JSONLD dangerouslyExposeHtml>
      <WebSite url={canonicalBaseUrl}>
        <GenericCollection type="potentialAction">
          <SearchAction
            query-input={`required name=${searchParamPlaceholder}`}
            target={`${canonicalBaseUrl}${buildUrlWithCountry(womenSearchUrl)}{${searchParamPlaceholder}}`}
          />
        </GenericCollection>
      </WebSite>
    </JSONLD>
  );
};

export default withCountryCode(HomeMicrodata);
